<template>
    <div>
        <DFab
            v-if="customer.cloudpit_account_id && userPermissions.includes('customer.view')"
            color="secondary"
            icon="lan-connect"
            :label="__('customers.customers.sso')"
            @click="loginViaSSO()"
        />
        <DFab
            v-if="!customer.cloudpit_account_id && userPermissions.includes('customer.edit')"
            v-c-tooltip="__('customers.customers.create_cloudpit_customer.explaination')"
            color="secondary"
            icon="lan-connect"
            :label="__('customers.customers.sso')"
            @click="openCreateCloudpitCustomerModal()"
        />
        <DModal
            v-if="showCustomerInactiveModal"
            :title="__('customers.customers.sso_error_customer_deactivated_title')"
            :message="__('customers.customers.sso_error_customer_deactivated_message', {status: customer.status })"
            is-error
            :show="showCustomerInactiveModal"
            @close="showCustomerInactiveModal = false"
        />
        <DModal
            v-if="showSsoErrorModal"
            :title="__('customers.customers.sso_error_customer_deactivated_title')"
            :message="__('customers.customers.sso_error_cloudpit_api_error')"
            is-error
            :show="showSsoErrorModal"
            @close="showSsoErrorModal = false"
        />
    </div>
</template>

<script>

export default {
    name: 'SSOFab',
    props: {
        customer: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    emits: ['open-modal'],
    data () {
        return {
            showCustomerInactiveModal: false,
            showSsoErrorModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        async generateSSOLink () {
            const self = this
            self.ssoLink = null
            try {
                const response = await window.axios.get(this.$route('customers.customers.sso', this.customer.id))
                self.loginStatus = ''
                self.ssoLink = response.data.url
            } catch (e) {
                self.loginStatus = 'failed'
            }
        },
        login () {
            window.open(this.ssoLink, '_blank').focus()
        },
        async loginViaSSO () {
            if (this.customer.status === 'inactive' || this.customer.status === 'restricted') {
                this.showCustomerInactiveModal = true
                return
            }
            await this.generateSSOLink()
            if (this.loginStatus === 'failed') {
                this.showSsoErrorModal = true
                return
            }
            this.login()
        },
        openCreateCloudpitCustomerModal () {
            this.$emit('open-modal')
        }
    }
}
</script>

<style scoped>

</style>
